import type { ReactNode } from 'react'
import { useAuth } from './AuthContext'
import { StaffTermsGate } from '../pages/club/StaffTermsGate'

/**
 * Route guard (mismo patrón que `RequireAuth`): envuelve TODAS las rutas del
 * panel de club (`/club`, `/club/players/:userId`) para que el gate de T&C
 * de staff sea bloqueante de verdad — no alcanza con ponerlo solo en
 * `ClubPage`, porque un manager podría navegar directo a
 * `/club/players/:userId` (link copiado, bookmark) sin pasar por ahí.
 *
 * Se monta DESPUÉS de `RequireAuth` (asume que ya hay sesión). Un jugador
 * puro (sin `club_memberships`) nunca ve este gate: `terms_ok` viene `true`
 * de `/auth/me` para ese caso (ver app/routers/auth.py::me).
 */
export function RequireStaffTerms({ children }: { children: ReactNode }) {
  const { user } = useAuth()

  const isClubStaff = (user?.club_memberships?.length ?? 0) > 0
  const termsBlocked = isClubStaff && !user?.terms_ok

  if (termsBlocked) {
    return <StaffTermsGate />
  }
  return <>{children}</>
}
